import { useSelector } from 'react-redux';
import FJImageInputTwo from '../../../../common/components/FJImageInput/FJImageInputTwo';
import FJConstant from '../../../../constants/FJConstant';
import { useCallback } from 'react';
import FJActionObjectErase from '../../../../redux/action/FJActionObjectErase';
import { useDispatch } from 'react-redux';
import { useMemo } from 'react';
import {
    UPLOAD_FILE_TYPE_IMAGE_EXTENDER,
    CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_IMAGES,
    UPLOAD_IMAGE_FILE_TYPE_NO_NEED_TRANSCODE,
} from '../../../../config/dataConfig/FJGenerateData';
import useLocalStore from '../../../../hooks/useLocalStore';
import FJActionEditPage from '../../../../redux/action/FJActionEditPage.js';

const FJImageInputContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const taskStatus = useSelector(state => state.common.taskStatus);
    const inputImageInfo = useSelector(state => state.objectErase.inputImageInfo);
    const isDraggingFile = useSelector(state => state.common.isDraggingFile);

    const isSmallComponent = useMemo(() => {
        return !!inputImageInfo;
    }, [inputImageInfo]);

    const _uploadImage = useCallback(
        file => {
            dispatch(FJActionObjectErase.uploadImageAction(file));
        },
        [dispatch],
    );

    const _openMediaLibrary = useCallback(() => {
        dispatch(
            FJActionEditPage.openMediaLibraryAction({
                uploadConfig: {
                    isMultiple: false,
                    maxMediaNum: 1,
                    selectedMediaIds: [],
                    acceptTypeWithTranscode:
                        UPLOAD_FILE_TYPE_IMAGE_EXTENDER + CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_IMAGES,
                    acceptTypeNoTranscode: UPLOAD_IMAGE_FILE_TYPE_NO_NEED_TRANSCODE,
                    suffixTranscode: CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_IMAGES,
                    // 媒体库的过滤规则
                    mediaFilterFunc: item => {
                        const mediaTypes = ['IMAGE'];
                        return mediaTypes.includes(item.type);
                    },
                    // 上传文件之后返回的数据
                    callbackOptions: {},
                },
            }),
        );
    }, [dispatch]);

    return (
        <FJImageInputTwo
            openMediaLibrary={_openMediaLibrary}
            disabled={taskStatus !== FJConstant.DEFAULT && taskStatus !== FJConstant.ERROR}
            uploadImg={_uploadImage}
            isSmallComponent={isSmallComponent}
            rightDraggingFile={isDraggingFile}
            acceptFile={UPLOAD_FILE_TYPE_IMAGE_EXTENDER + CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_IMAGES}
        />
    );
};

export default FJImageInputContainer;
